import src from "IMAGE";
export default { src, width: 1074, height: 219, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAIklEQVR42nXDIQEAAAgDwWkIDjnRFEA9CSZOt4XXiAm85AHPmTKrDlnBogAAAABJRU5ErkJggg=="};
